
import Vue from 'vue'
import VueRouter from 'vue-router'
import App from './App.vue'
import router from './router.js'
import VueI18n from 'vue-i18n'
import messages from './i18n.js'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import FacebookLoginPlugin from './network/facebook.js';

// const apiHost = "https://app.doutorbingo.com",
// cdnHost = "https://d2rzfffph148bz.cloudfront.net/web_store/images",
// paymentHost = "https://www.drbingo.com";

var hostname = window.location.hostname;
const cdnHost = hostname == 'store.drbingo.com' || hostname == 'store.doutorbingo.com'
    ? 'https://d2rzfffph148bz.cloudfront.net/web_store/images'
    : 'http://s3.amazonaws.com/doctor-bingo-staging/web_store/images';

/*
const vue_fb = {}
vue_fb.install = function install(Vue, options) {
    (function(d, s, id){
        var js, fjs = d.getElementsByTagName(s)[0]
        if (d.getElementById(id)) {return}
        js = d.createElement(s)
        js.id = id
        js.src = "//connect.facebook.net/en_US/sdk.js"
        fjs.parentNode.insertBefore(js, fjs)
        console.log('setting fb sdk')
    }(document, 'script', 'facebook-jssdk'))

    window.fbAsyncInit = function onSDKInit() {
        //console.log("Initiated", options);
        FB.init(options)
        FB.AppEvents.logPageView()
        Vue.FB = FB
        window.dispatchEvent(new Event('fb-sdk-ready'))
    }
    Vue.FB = undefined
}

var hostname = window.location.hostname;
const fbAppId = hostname == 'store.drbingo.com' || hostname == 'store.doutorbingo.com' ? '346029962096610' : '998332483533018';

Vue.use(vue_fb, {
    appId: fbAppId,
    autoLogAppEvents: true,
    xfbml: true,
    version: 'v6.0'
})
    */

Vue.use(VueRouter)
Vue.use(VueI18n)
Vue.use(VueAwesomeSwiper)
Vue.use(FacebookLoginPlugin);

const i18n = new VueI18n({
    locale: /(en)|(es)|(pt)/.test(navigator.language) ? navigator.language.substring(0, 2): 'en',
    messages
})

Vue.prototype._i18n = i18n;
Vue.prototype._global = {
    root: "https://store.doutorbingo.com",
    assetsRoot: cdnHost,
    testAssetsRoot: "http://myoperatorapi.com/images"
};

new Vue({
  el: '#app',
  render: h => h(App),
  router,
  i18n
})



// WEBPACK FOOTER //
// ./src/main.js